import React from 'react';
import PropTypes from 'prop-types';
import { Element } from 'react-scroll';
import { DeviceItem, DevicePopover, DeviceTile } from '@saucelabs/sl-component-device-grid';

import Styles from './RealDevicesGridItem.styles';

const RealDevicesGridItem = ({
  closeTileDetails,
  device,
  handleClick,
  handleDetailsClick,
  selected,
  detailsOpen,
}) => {
  const freeDeviceLabel = device.freeOfCharge && <span className={Styles['free-device']}>Free</span>;
  const privateDeviceLabel = device.isPrivate() && <span className={Styles['private-device']}>Private</span>;
  const specifications = device.getFullSpecifications();

  return (
    <Element name={device.compositeId}>
      <DeviceItem>
        <DeviceTile
          disabled={device.disabled}
          id={device.descriptorId}
          image={device.getImageUrl()}
          label={privateDeviceLabel || freeDeviceLabel}
          name={device.name}
          onClick={handleClick}
          onDetailsClick={handleDetailsClick}
          selected={selected}
        >
          <div>
            <div>{device.getPrettyOsAndOsVersion()}</div>
            <div>{`Screen: ${device.getPrettyScreenSizeAndResolution()}`}</div>
            <div>{`Location: ${device.getDataCenterName()}`}</div>
          </div>
        </DeviceTile>
        {detailsOpen && (
          <DevicePopover
            name={device.name}
            onClose={closeTileDetails}
          >
            {Object.entries(specifications).map(([key, specification]) => (
              <div key={key}>{`${key}: ${specification}`}</div>
            ))}
          </DevicePopover>
        )}
      </DeviceItem>
    </Element>
  );
};

RealDevicesGridItem.propTypes = {
  closeTileDetails: PropTypes.func.isRequired,
  detailsOpen: PropTypes.bool.isRequired,
  device: PropTypes.object.isRequired,
  handleClick: PropTypes.func.isRequired,
  handleDetailsClick: PropTypes.func.isRequired,
  selected: PropTypes.bool.isRequired,
};

export default RealDevicesGridItem;
